import ENTexts from './/en.json'
import DETexts from './/de.json'
import SKTexts from './/sk.json'
import FRTexts from './/fr.json'
import ESTexts from './/es.json'

export const messages = {
  en: ENTexts,
  de: DETexts,
  sk: SKTexts,
  fr: FRTexts,
  es: ESTexts,
}
